import { APIService } from "services";

export const getTransactions = async (pageNo, pageSize, search) => {
  let res;
  if (search.length === 0) {
    res = await getAllTransactions(pageNo, pageSize);
  } else {
    try {
      res = await searchTransactions(search, pageNo, pageSize);
    } catch (err) {
      return { records: [], totalCount: 0 };
    }
  }
  if (res && res.data) {
    return res.data;
  } else {
    return { records: [], totalCount: 0 };
  }
};

export const addTransactions = (data) => {
  return APIService.api().post(`/transactions`, data);
};
export const updateTransactions = (id, data) => {
  return APIService.api().patch(`/transactions/${id}`, data);
};
export const getAllTransactions = (pageNo, pageSize) => {
  return APIService.api().get(
    `/transactions/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const getOneTransactions = (id) => {
  return APIService.api().get(`/transactions/${id}`);
};
export const searchTransactions = (searchKey, pageNo, pageSize) => {
  return APIService.api().get(
    `/transactions/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const deleteTransactions = (id) => {
  return APIService.api().delete(`/transactions/${id}`);
};
